import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { PurchaseShell } from "../features/purchase/PurchaseShell";
import { SupplierStatement } from "../features/purchase/SupplierStatement";
import { NeuCard } from "../components/neu/Neu";
import { StatusChip } from "../components/data/StatusChip";
import { getSupplier } from "../api/purchases";
import { localName } from "../lib/localName";

const ROWS = [["legalName", (s) => s.legal_name], ["nameAr", (s) => s.name_ar],
              ["code", (s) => s.code], ["trn", (s) => s.tax?.trn],
              ["currency", (s) => s.currency], ["phone", (s) => s.phone],
              ["email", (s) => s.email], ["iban", (s) => s.bank?.iban],
              ["creditLimit", (s) => s.credit_limit]];

// صفحة مورّد واحد: بياناته وكشف حسابه.
export default function PurchaseSupplierPage() {
  const { t } = useTranslation();
  const { supplierId } = useParams();
  const navigate = useNavigate();
  const [supplier, setSupplier] = useState(null);

  useEffect(() => {
    getSupplier(supplierId).then(setSupplier)
      .catch(() => navigate("/purchases/suppliers"));
  }, [supplierId, navigate]);

  return (
    <PurchaseShell titleKey="suppliers">
      {!supplier ? null : (
        <>
          <NeuCard className="grid gap-3 p-5" data-testid="supplier-detail">
            <div className="flex flex-wrap items-center gap-3">
              <p className="min-w-0 flex-1 truncate text-base font-bold">
                {localName(supplier)}
              </p>
              <StatusChip state={supplier.is_archived ? "archived" : "active"}
                          labelKey="purchases.supplierStates" />
            </div>
            <div className="grid gap-3 sm:grid-cols-3">
              {ROWS.map(([key, pick]) => (
                <div key={key} className="rounded-2xl p-3 shadow-neu-in">
                  <p className="text-[11px] font-bold text-muted-foreground">
                    {t(`purchases.${key}`)}
                  </p>
                  <p className="num truncate text-xs font-bold">{pick(supplier) || "—"}</p>
                </div>
              ))}
            </div>
          </NeuCard>
          <SupplierStatement supplierId={supplierId} />
        </>
      )}
    </PurchaseShell>
  );
}
